import store from '../store';
import Constants from '../config/constants';
import { serviceGetIncentiveReportOverall} from "../services/IncentiveReport.service";

export const FETCH_INIT = 'FETCH_INIT_OVERALL_REPORT';
export const FETCHED = 'FETCHED_OVERALL_REPORT';
export const FETCHED_FAIL = 'FETCHED_FAIL_OVERALL_REPORT';
export const FETCHED_FILTER = 'FETCHED_FILTER_OVERALL_REPORT';
export const FETCH_NEXT = 'FETCH_NEXT_OVERALL_REPORT';
export const FILTER = 'FILTER_OVERALL_REPORT'; 
export const RESET_FILTER = 'RESET_FILTER_OVERALL_REPORT';
export const SET_SORTING = 'SET_SORTING_OVERALL_REPORT';
export const SET_FILTER = 'SET_FILTER_OVERALL_REPORT';
export const SET_PAGE = 'SET_PAGE_OVERALL_REPORT';
export const CHANGE_PAGE = 'CHANGE_PAGE_OVERALL_REPORT';
export const CHANGE_STATUS= 'CHANGE_STATE_OVERALL_REPORT';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_OVERALL_REPORT';
export const CREATE_DATA = 'CREATE_OVERALL_REPORT';
export const UPDATE_DATA = 'UPDATE_OVERALL_REPORT';
export const DELETE_ITEM = 'DELETE_OVERALL_REPORT';


export function actionFetchIncentiveReportOverall(index = 1, sorting = {}, filter = {}) {
    const request = serviceGetIncentiveReportOverall({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionChangePageIncentiveReportOverall(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}


export function actionFilterIncentiveReportOverall(value) {
    const request = null;
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusIncentiveReportOverall(id, status) {
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterIncentiveReportOverall() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageIncentiveReportOverall(page, extraPayload = {}) {
    const stateData = store.getState().overall_report;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data; 
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchIncentiveReportOverall(serverPage + 1, sortingData, {query, query_data: queryData,   ...extraPayload}));
    }

    console.log(currentPage, totalLength);
    return {
        type: CHANGE_PAGE,
        payload: page,
    };

}
